<template>
  <div class="dashboard-tooltip-container">
    <LeftAlignTooltip>
      <InfoIcon size="medium"></InfoIcon>
      <template v-slot:content>
        <slot name="tooltipText"></slot>
      </template>
    </LeftAlignTooltip>
    <span v-if="$slots.mainText" class="main-text">
      <slot name="mainText"></slot>
    </span>
  </div>
</template>
<script>
import { LeftAlignTooltip, InfoIcon } from '@mikmak/components';

export default {
  components: {
    LeftAlignTooltip,
    InfoIcon,
  },
};
</script>
<style scoped>
.dashboard-tooltip-container > div {
  vertical-align: middle;
}

.main-text {
  font-size: 16px;
  color: #778699;
}
</style>
<style>
/*
  Overwrite tooltip styles.
  TODO: Make underlying component more flexible.
  Perhaps will require (or be much easier with) external library.
*/
.dashboard-tooltip-container .tooltip-wrapper.center {
  width: 234px;
  /* Move left half the width to center the tooltip */
  left: -117px;
  margin-top: 0;
  margin-left: 0;
}

.dashboard-tooltip-container .tooltip-wrapper .arrow {
  top: -2px !important;
}
</style>
